import { render } from "./UploadComponent.vue?vue&type=template&id=34306da2&scoped=true"
import script from "./UploadComponent.vue?vue&type=script&lang=js"
export * from "./UploadComponent.vue?vue&type=script&lang=js"

import "./UploadComponent.vue?vue&type=style&index=0&id=34306da2&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34306da2"]])

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile,QIcon,QBtn});
